import React from 'react';
import { Space, Button, Tooltip } from 'antd';
import { Influencer } from '../../../services/marketingAPI';
import { NavigateFunction } from 'react-router-dom';
import { InfluencerInfoCell } from './InfluencerTableConfigComponents/InfluencerInfoCell';
import { EmailCell, ProfileLinkCell, BioCell } from './InfluencerTableConfigComponents/ContactInfoCells';
import { FollowersCell, TotalViewsCell, AvgViewsCell, EngagementCell, VideoCountCell } from './InfluencerTableConfigComponents/StatsCells';
import { RegistrationTimeCell, UpdateFrequencyCell, LastUpdatedCell } from './InfluencerTableConfigComponents/DateCells';
import { AIAnalysisCell, CategoryTagsCell, CollaborationStatsCell, StatusCell } from './InfluencerTableConfigComponents/AnalysisCells';

export const getInfluencerColumns = (
    navigate: NavigateFunction,
    handleDelete: (id: number) => void
) => [
        {
            title: 'ID',
            key: 'id',
            width: 70,
            fixed: 'left' as const,
            render: (text: string, record: Influencer) => <span style={{ color: '#999', fontSize: '12px' }}>#{record.id}</span>
        },
        {
            title: '红人信息',
            key: 'name',
            width: 220,
            fixed: 'left' as const,
            render: (_: string, record: Influencer) => <InfluencerInfoCell record={record} />,
        },
        {
            title: '注册时间',
            key: 'join_date',
            width: 180,
            render: (_: string, record: Influencer) => <RegistrationTimeCell record={record} />
        },
        {
            title: '邮箱',
            key: 'email',
            width: 200,
            render: (_: string, record: Influencer) => <EmailCell record={record} />
        },
        {
            title: '主页链接',
            key: 'account_info',
            width: 180,
            render: (_: string, record: Influencer) => <ProfileLinkCell record={record} />
        },
        {
            title: '粉丝数',
            key: 'followers',
            width: 100,
            render: (_: string, record: Influencer) => <FollowersCell record={record} />
        },
        {
            title: '总观看量',
            key: 'total_views',
            width: 120,
            render: (_: string, record: Influencer) => <TotalViewsCell record={record} />
        },
        {
            title: (
                <Tooltip title="最近12个视频的平均播放量">
                    <span>平均观看量 <span style={{ fontSize: 12, color: '#999' }}>?</span></span>
                </Tooltip>
            ),
            key: 'views',
            width: 120,
            render: (_: string, record: Influencer) => <AvgViewsCell record={record} />
        },
        {
            title: (
                <Tooltip title="平均观看量 / 粉丝数">
                    <span>互动率 <span style={{ fontSize: 12, color: '#999' }}>?</span></span>
                </Tooltip>
            ),
            key: 'engagement',
            width: 100,
            render: (_: string, record: Influencer) => <EngagementCell record={record} />
        },
        {
            title: '更新时间',
            key: 'updated_at',
            width: 110,
            render: (_: string, record: Influencer) => <LastUpdatedCell record={record} />
        },
        {
            title: '视频数',
            key: 'video_count',
            width: 80,
            render: (_: string, record: Influencer) => <VideoCountCell record={record} />
        },
        {
            title: '更新频率',
            key: 'frequency',
            width: 100,
            render: (_: string, record: Influencer) => <UpdateFrequencyCell record={record} />
        },
        {
            title: '个人说明',
            key: 'bio',
            width: 180,
            render: (_: string, record: Influencer) => <BioCell record={record} />
        },
        {
            title: 'AI 深度评估',
            key: 'analysis',
            width: 200,
            render: (_: string, record: Influencer) => <AIAnalysisCell record={record} />
        },
        {
            title: '分类 & 标签',
            key: 'category',
            width: 200,
            render: (_: string, record: Influencer) => <CategoryTagsCell record={record} />
        },
        {
            title: '合作概况',
            key: 'stats',
            width: 120,
            render: (_: string, record: Influencer) => <CollaborationStatsCell record={record} />
        },
        {
            title: '状态',
            key: 'status',
            width: 100,
            dataIndex: 'status',
            render: (status: string) => <StatusCell status={status} />
        },
        {
            title: '操作',
            key: 'action',
            fixed: 'right' as const,
            width: 150,
            render: (text: string, record: Influencer) => (
                <Space>
                    <Button type="link" size="small" onClick={() => navigate(`/marketing/influencers/${record.id}`)}>
                        详情
                    </Button>
                    <Button type="text" danger size="small" onClick={() => handleDelete(record.id)}>
                        删除
                    </Button>
                </Space>
            )
        }
    ];
